<div
  class="flex gap-2 align-items-center cursor-pointer"
  (click)="togglePanel()"
>
  <app-base-avatar [label]="email[0]" shape="circle"> </app-base-avatar>
  <app-base-label [label]="email" ngClass="mb-0 pointer-events-none">
  </app-base-label>
</div>
<app-base-overlay-panel>
  <div class="flex gap-3" panel-body>
    <app-base-avatar [size]="'xlarge'" [label]="email[0]" shape="circle">
    </app-base-avatar>
    <div>
      <label class="block font-semibold text-xl mb-1">
        {{ name }}
      </label>
      <label class="block font-normal text-base mb-3">
        {{ email }}
      </label>
      <app-base-button
        (click)="logout()"
        [label]="'LOGOUT' | translate"
        [outlined]="true"
      ></app-base-button>
    </div>
  </div>
</app-base-overlay-panel>
